"use client";

import { Field } from "@sitecore-jss/sitecore-jss-nextjs";
import { VideoPlayer as CloudinaryVideoPlayer } from "cloudinary-video-player";
import { useEffect, useRef } from "react";
import { ComponentProps } from "../../types/component-props";

import classes from "./video-player.module.css";

type VideoPlayerProps = ComponentProps & {
  fields: {
    cloudinaryVideoId: Field<string>;
    posterImage: Field<{ src: string }>;
  };
};

const VideoPlayer = (props: VideoPlayerProps) => {
  const playerRef = useRef<CloudinaryVideoPlayer | null>(null);
  const publicId = props.fields.cloudinaryVideoId?.value;
  const posterImage = props.fields.posterImage?.value.src;
  const videoId = "cloudinary-video-player";

  useEffect(() => {
    if (playerRef.current) return;

    const setupPlayer = async () => {
      const cloudinary = (await import("cloudinary-video-player")).default;
      // @ts-expect-error no .d.ts exists for the adaptive streaming module from the package so adding this for now
      await import("cloudinary-video-player/adaptive-streaming.js");
      await import("cloudinary-video-player/cld-video-player.min.css");

      const CLOUD_NAME =
        process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME || "asos-prod";

      playerRef.current = cloudinary.videoPlayer(videoId, {
        cloudName: CLOUD_NAME,
        secureDistribution: "www.asos-video.com",
        privateCdn: true,
        chapters: true,
        controls: true,
        autoPlay: false,
        muted: false,
        loop: true,
        showJumpControls: true,
        hideContextMenu: true,
        showLogo: false,
        transformation: [
          {
            effect: ["volume:auto"],
          },
        ],
        sourceTypes: ["hls"],
        posterOptions: {
          publicId: posterImage,
        },
      });

      playerRef.current.source(publicId);
    };

    setupPlayer();

    return () => {
      playerRef.current?.dispose();
    };
  }, [publicId]);

  return (
    <div className={classes.playerContainer}>
      <video id={videoId} className="cld-video-player cld-fluid"></video>
    </div>
  );
};

export default VideoPlayer;
